// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__ilTPF","title":"InfoRow_title__t8mwj"};